import Service from './Service';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import {
    GetComparePatentText,
} from '@/infrastructure/api-functions/core-search-api/core-search-api';
import _ from 'lodash';

export default class ComparePatentService extends Service {
    private patentId: string;
    private compareId: string;
    public completed: boolean;
    constructor({
        patentId,
        compareId,
    }) {
        super();
        this.patentId = patentId;
        this.compareId = compareId;
        this.completed = false;
    }

    async getPatentText({ lang, type, initParams }) {
        const service = injectService<GetComparePatentText>(GetComparePatentText);
        const data = await service.getComparePatentText({
            compare_id: this.compareId,
            patent_id: this.patentId,
            lang: lang,
            field_type: type,
            overview_request: initParams,
        });

        const obj:{ text:string; lang: string; curRequestLang:string;} = {
            text: '',
            lang: '',
            curRequestLang: lang, //用于是否是同一批请求，避免请求先发后至
        };
        if (type === 'CLMS') {
            obj.text = data.CLMS;
            obj.lang = data.CLMS_TRAN_LANG;
        } else if (type === 'DESC') {
            obj.text = data.DESC;
            obj.lang = data.DESC_LANG;
        }

        return {
            ...obj,
            ...data,
            text: ComparePatentService.transformPatentTextUseHtmlWrapper(obj.text, '.patsnap-compare-hit', 'compare-hit'),
        };

    }

    setCompareCompleted(status:boolean) {
        this.completed = status;
    }

    static transformPatentTextUseHtmlWrapper(htmlString:string, targetSelector: string, customElement: string) {
        if (!htmlString) return '';
        // 创建一个虚拟的 DOM 元素
        const parser = new DOMParser();
        const parsedHtml = parser.parseFromString(`<div id="transform__html__wrapper">${htmlString}</div>`, 'text/html');
        const tempElement = parsedHtml.querySelectorAll(targetSelector);

        function wrapTextNodes(node:Element) {
            if (node.nodeType === Node.TEXT_NODE) {
                const parentNode = node.parentNode;
                // @ts-ignore
                const parentTagName = parentNode?.tagName;
                if (parentTagName && parentTagName.toLowerCase() === customElement) {
                    return;
                }

                // 创建一个自定义标签
                const compareHit = document.createElement(customElement);
                compareHit.className = customElement;
                // 把当前文本节点的内容放入自定义标签
                compareHit.textContent = node.textContent;
                // 用自定义标签替换原始文本节点
                node.parentNode && node.parentNode.replaceChild(compareHit, node);
            } else {
                // 遍历当前节点的子节点
                node.childNodes.forEach(function(childNode) {
                    wrapTextNodes(<HTMLElement>childNode);
                });
            }
        }

        // 从根节点开始遍历并包裹文本节点
        _.forEach(tempElement, item => {
            wrapTextNodes(item);
        });

        const wrapper = parsedHtml.getElementById('transform__html__wrapper');
        return wrapper?.innerHTML || '';
    }
}
